










































































import AvailabilityForm from "@/components/booking/AvailabilityForm.vue";
import ResourceList from "@/components/booking/ResourceList.vue";
import { timeFormatRule } from "@/lib/rules/dateRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import {
  BookingAvailabilityGen,
  BookingBookingInformationDtoGen,
  BookingCreateBookingDtoGen,
  BookingResourceViewModelGen,
  BookingServiceViewModelGen,
  BookingUpdateBookingDtoGen
} from "@/services/booking/v1/data-contracts";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { formatYearsMonthDay, formatHoursAndMinutes } from "@/lib/utility/date-helper";

export class BookingDto implements BookingCreateBookingDtoGen {
  /** @inheritdoc */
  resourceId = "";

  /** @inheritdoc */
  end = 0;

  /** @inheritdoc */
  start = 0;

  /**
   * @inheritdoc
   */
  bookingInformation: BookingBookingInformationDtoGen = {
    notes: ""
  };

  private _startDate = new Date(this.start);
  private _endDate = new Date(this.start);

  /**
   * Internal string to manipulate via date picker
   */
  private _startDateString = "";

  /**
   * Internal string to manipulate via time picker
   */
  private _startTimeString = "";

  /**
   * Internal string to manipulate via time picker
   */
  private _endTimeString = "";

  constructor(booking?: BookingUpdateBookingDtoGen | any) {
    if (booking) {
      this.resourceId = booking.resourceId || "";

      this.bookingInformation = booking.bookingInformation || { notes: "" };

      const dateStart = new Date(booking.start);
      this.start = booking.start;

      this.startDate = formatYearsMonthDay(dateStart);
      this.startTime = formatHoursAndMinutes(dateStart);

      const dateEnd = new Date(booking.end);
      this.start = booking.end;
      this.endTime = formatHoursAndMinutes(dateEnd);
    }
  }

  /**
   * Sets the start date and stores internal state
   * @param dateString YYYY-MM-DD
   */
  set startDate(dateString: string) {
    Vue.$log.debug(dateString);
    if (!dateString.includes("-")) {
      Vue.$log.error("Cannot set date string without  -");
      return;
    }

    const [year, month, date] = dateString.split("-");
    Vue.$log.debug(year, month, date);

    this._startDate.setFullYear(+year);
    this._startDate.setMonth(+month - 1);
    this._startDate.setDate(+date);
    this._endDate.setFullYear(+year);
    this._endDate.setMonth(+month - 1);
    this._endDate.setDate(+date);

    this._startDateString = dateString;
  }

  /**
   * Returns the internal start date state
   */
  get startDate() {
    return this._startDateString;
  }

  /**
   * Sets the start time and stores internal state
   */
  set startTime(time: string) {
    Vue.$log.debug(time);
    if (!time.includes(":")) {
      Vue.$log.error("Cannot set time string without  :");
      return;
    }

    const [hours, minutes] = time.split(":");
    this._startDate.setHours(+hours, +minutes, 0, 0);

    this._startTimeString = time;
  }

  /**
   * Returns the start time internal state
   */
  get startTime() {
    return this._startTimeString;
  }

  /**
   * Sets the end time and stores internal state
   */
  set endTime(time: string) {
    Vue.$log.debug(time);
    if (!time.includes(":")) {
      Vue.$log.error("Cannot set time string without  :");
      return;
    }

    const [hours, minutes] = time.split(":");
    this._endDate.setHours(+hours, +minutes, 0, 0);

    this._endTimeString = time;
  }

  /**
   * Returns the end time internal state
   */
  get endTime() {
    return this._endTimeString;
  }

  /**
   * Converts a time to the lowest half like 08:13 to 08:00, 08:35 to 08:30.
   * In the UI this leads to a more consistent experience as it takes the half hour below the click.
   * @param time "HH:MM"
   */
  setNearest30TimeString(time: string) {
    if (!time.includes(":")) {
      Vue.$log.warn(
        `The specified value "${time}" does not conform to the required format.  The format is "HH:mm" where HH is 00-23, mm is 00-59.`
      );

      return;
    }

    const [hours, minutes] = time.split(":");
    const m = Math.floor(+minutes / 30) * 30;

    const timeString = `${hours.padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
    this.startTime = timeString;
  }

  toDto(): BookingCreateBookingDtoGen {
    const dto: BookingCreateBookingDtoGen = {
      start: this._startDate.getTime(),
      end: this._endDate.getTime()
    };

    return dto;
  }

  updateDto(): BookingUpdateBookingDtoGen {
    return {
      resourceId: this.resourceId,
      start: this._startDate.getTime() || this.start,
      end: this._endDate.getTime() || this.end,
      bookingInformation: this.bookingInformation
    };
  }
}

@Component({
  components: { AvailabilityForm, ResourceList }
})
export default class BookingForm extends Vue {
  isValid = false;
  isDisabled = true;

  @Prop({ default: false })
  isCreate!: boolean;

  @Prop()
  value!: BookingDto;

  @Prop({ default: false })
  isLoading!: boolean;

  @Prop()
  services?: BookingServiceViewModelGen[];

  @Prop()
  resources?: BookingResourceViewModelGen[];

  @Prop()
  availability?: BookingAvailabilityGen[];

  @Watch("isValid")
  emitIsValid() {
    this.$emit("valid", this.isValid);
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get timeFormatRule() {
    return [timeFormatRule()];
  }

  get disabled() {
    return this.isLoading;
  }
}
